
// -------------------------------
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";
import "react-image-crop/dist/ReactCrop.css";


/**
 * mountApp()
 * index.html tarafından import edilip çağrılır.
 * Eğer #app-root bulunamazsa hata verir.
 */
export function mountApp() {
  const container = document.getElementById("app-root");
  if (!container) {
    console.error("⚠️ #app-root bulunamadı! Uygulama başlatılamadı.");
    return;
  }

  try {
    const root = createRoot(container);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } catch (error) {
    console.error("🚨 Uygulama başlatılamadı:", error);
  }
}

// otomatik başlatma
mountApp();
